export default {"src":"/expo/_next/static/media/box-mobile.629317e9.svg","height":327,"width":320,"blurWidth":0,"blurHeight":0};